import { useTranslation } from 'react-i18next';

export const keyPrefix = 'foldableEntity';
export const useFoldableEntityTranslation = () => useTranslation('shared', { keyPrefix });
export const ruRu = ({
  [keyPrefix]: {
    empty: 'Нет данных',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    empty: 'No data',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    empty: 'Sem dados',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    empty: 'No hay datos',
  },
}) as Record<string, unknown>;
